import React from "react";
import "../../asset/css/App.css";
import seLogo from "../../asset/images/selogo.png";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import CloseIcon from '@mui/icons-material/Close';
import {
    PublishMessageClose
  } from "shared-components/src/Infrastructure/PostMessageService";

const Header = (props) => {
    const navigate = useNavigate();
    const onGoHomeClick = () => {
      navigate('/')
  }
  const handleCloseIframe = () =>{
    if (window.self !== window.top) {
        PublishMessageClose();
    } 
  }
  const cnsReceiveMessage = (event) => {
    if (event.data.fn === "cnsClose") {
        window.parent.postMessage(event.data, '*')
        PublishMessageClose();
        navigate(`/`)
    }
}
  React.useEffect(() => {
    window.addEventListener("message", cnsReceiveMessage);
    return () => {
        window.removeEventListener("message", cnsReceiveMessage);
    };
}, [window.addEventListener("message", cnsReceiveMessage)]);
    return (
        <>
           {window.self !== window.top ? <></> : <div className="header">
                <div className={window.self !== window.top ? "main_logo_event" : "main-logo" }>
                    <a onClick={onGoHomeClick}>
                    <img src={seLogo} /> 
                    </a>
                    <label>{props.HeaderProductJson}</label>
                </div>
                {
                    window.self !== window.top ?  
                    <div className='previous-btn-sec previous-btn-sec-header'>
                        <Button
                    onClick={() => {
                        handleCloseIframe();
                    }}
                    className={"back-to-subset-list-btn"}
                >
                    <CloseIcon />
                </Button>
                </div> 
                :<></>
                }
               
            </div>}
        </>
    )
}

export default Header;